import _ from 'lodash';
import { Loading } from 'components/loading/index';
import { useFilteredData } from './hooks';
import { ParentItem } from './parent-item';
import { ChildItem } from './child-item';

export const TreeNode = ({ targetFolder }) => {
  const [query, data] = useFilteredData(targetFolder);
  const folders = _.filter(_.reject(data?.folders, 'isEmpty'), { matchesFilter: true });
  const projects = _.filter(data?.projects || [], { matchesFilter: true });

  return query?.isSuccess ? (
    <>
      {_.map(folders, (folder) => (
        <ParentItem title={folder?.name} id={folder?.id} key={folder?.id} folder={targetFolder} />
      ))}
      {_.map(projects, (project) => (
        <ChildItem title={project?.name} id={project?.id} key={project?.id} folder={targetFolder} />
      ))}
    </>
  ) : (<Loading centered />);
};
